<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px">
    <v-navigation-drawer style="z-index: 999999 !important" :width="500" v-model="settingsToggle" absolute temporary
      right>
      <v-spacer></v-spacer>
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="logoSelectedNodeId"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title> {{ nameSelectedNodeId }} </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon color="primary" dark @click="savePluginSettings(settingsData)">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>
      <div style="padding: 20px; text-align: justify">
        {{ descriptionSelectedNodeId }}
      </div>
      <!--
      <v-divider></v-divider>
      <div style="padding: 20px; text-align: justify">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-play</v-icon>
            </v-btn>
          </template>
          <span>Execute the plugin</span>
        </v-tooltip>
      </div>
      -->
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="(item, key) in settingsData" :key="key">
          <v-list-item-content>
            <v-list-item-title>
              Request
              <v-subheader>{{ key }} *</v-subheader>
              <v-text-field v-if="typeof(settingsData[key]) == 'string'" outlined name="input-7-4"
                v-model="settingsData[key]" placeholder="$.variable"></v-text-field>
              <v-select v-else-if="typeof (settingsData[key]) == 'object'" :items="settingsData[key]" label="Choice"
                outlined v-model="settingsData[key]">
              </v-select>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div style="padding: 20px; text-align: justify">
        <vue-json-pretty :path="'res'" :data="settingsData" :highlightMouseoverNode="1">
        </vue-json-pretty>
      </div>
      <v-divider></v-divider>
      <div style="padding: 20px; text-align: justify">
        <v-list dense>
          <v-list-item :key="key">
            <v-list-item-content>
              <v-list-item-title>
                Response

              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <vue-json-pretty :path="'res'" :data="outputData" :highlightMouseoverNode="1">
        </vue-json-pretty>


      </div>
    </v-navigation-drawer>

    <div class="row" style="padding-top: 20px">
      <div class="col-2">
        <div class="row" style="margin-top: 0px; height: 100%">
          <v-navigation-drawer permanent width="100%" height="100%">
            <h2 style="
                padding: 20px;
                margin-bottom: 0;
                text-align: justify;
                color: black;
              ">
              Plugins
            </h2>
            <div style="
                padding-left: 20px;
                padding-right: 20px;
                text-align: justify;
              ">
              <input type="text" dark class="form-control" v-model="searchplugin" placeholder="Search the store"
                style="color: black" />
            </div>
            <v-divider></v-divider>
            <div style="
                padding-left: 20px;
                padding-right: 20px;
                text-align: justify;
              ">
              <v-list-item v-for="n in filteredList" :key="n" draggable="true" :data-node="n.item"
                @dragstart="drag($event)" class="drag-drawflow single-node">
                <v-list-item-avatar>
                  <v-img :src="n['logo']"></v-img>
                </v-list-item-avatar>

                <v-list-item-content class="">
                  <v-list-item-title>{{ n["title"] }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                  n["subtitle"]
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-navigation-drawer>
        </div>
      </div>
      <div class="col-7" style="background:#fefefe;border:0.3px solid grey">
        <div class="row">
          <!-- to move to a different component -->

          <!-- END -->
          <div class="container2" id="container">
            <div id="drawflow" @drop="drop($event)" @dragover="allowDrop($event)" ref="drawflow">
              <h2 style="margin: 20px; text-align: justify; color: black">
                Orchestrator
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row" style="margin-top: 0px; height: 100%">
          <v-navigation-drawer permanent width="100%" height="100%">
            <div class="row" style="padding: 20px; margin-bottom: 0; text-align: justify">
              <div class="col-10">
                <h2 style="color: black">Workflows</h2>
              </div>
              <div class="col-1">
                <v-dialog v-model="dialogCreateWorkflow" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      New Workflow
                    </v-card-title>

                    <v-card-text>
                      Insert the name of the new workflow
                      <v-text-field v-model="newWorkflowName"></v-text-field>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click.stop="createNewWorkflow()">
                        Create
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>
            </div>

            <v-divider></v-divider>
            <v-subheader inset>Workflow name</v-subheader>
            <div style="padding: 20px; text-align: justify">
              <v-list-item>


                <v-list-item-content class="">
                  <v-list-item-title>
                    <v-text-field v-model="currentWorkflowName" outlined clearable></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-divider></v-divider>
            <div style="padding: 20px; text-align: justify">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="executeWorkflow()">
                    <v-icon>mdi-play</v-icon>
                  </v-btn>
                </template>
                <span>Run workflow</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="deployWorkflow()">
                    <v-icon>mdi-rocket-launch</v-icon>
                  </v-btn>
                </template>
                <span>Deploy workflow</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="saveWorkflow()">
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Save workflow</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="exportEditor()">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Export workflow in JSON format</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="handleFileImport">
                    <v-icon>mdi-upload</v-icon>
                  </v-btn>
                </template>
                <input ref="uploader" class="d-none" type="file" @change="onFileChanged" />
                <span>Import workflow in JSON format</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click.stop="openSettingsDialog()">
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <span>Node settings</span>
              </v-tooltip>
            </div>
            <v-divider></v-divider>
            <div style="
                padding: 20px;
                text-align: justify;
                height: 300px;
                overflow-y: scroll;
              ">
              <v-list subheader two-line>
                <v-subheader inset>Your workflows</v-subheader>
                <v-list-item v-for="(item, i) in this.allWorkflows" :key="i">
                  <v-list-item-avatar>
                    <v-btn icon @click="openWorkflow(item.id)">
                      <v-icon color="grey lighten-1">mdi-upload</v-icon>
                    </v-btn>
                  </v-list-item-avatar>
                  <v-list-item-content class="">
                    <v-list-item-title v-text="item.workflow_name">
                    </v-list-item-title>
                    <v-list-item-subtitle v-text="'created: ' + toReadableDate(item.created_at)"></v-list-item-subtitle>
                    <v-list-item-subtitle v-text="'updated: ' + toReadableDate(item.updated_at)"></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action> </v-list-item-action>
                  <v-list-item-action>
                    <v-btn icon @click="deleteWorkflow(item.id)">
                      <v-icon color="red lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
            <v-divider></v-divider>
            <v-tabs style="padding: 20px; text-align: justify" v-model="tab">
              <v-tab href="#tab-runs">Runs</v-tab>
              <v-tab href="#tab-errors">Errors</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :value="'tab-runs'">
                <div style="padding: 20px; text-align: justify; height: 300px;overflow-y: scroll;">
                  <v-list subheader two-line>
                    <v-list-item v-for="(item, i) in this.workflowExecutions" :key="i">
                      <v-list-item-avatar v-if="item.status == 'SUCCEEDED'">
                        <v-icon color="green  darken-1">mdi-check-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-avatar v-if="item.status == 'FAILED'">
                        <v-icon color="red lighten-1">mdi-close-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-avatar v-if="item.status == 'RUNNING'">
                        <v-icon color="grey lighten-1">mdi-circle-slice-3</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content class="">
                        <v-list-item-title v-text="item.workflow_name">
                        </v-list-item-title>
                        <v-list-item-subtitle v-text="'startDate: ' + item.startDate">
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-text="'stopDate: ' + item.stopDate">
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>


                      </v-list-item-action>
                      <v-dialog v-model="dialogGetExecutionDetails[i]" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon @click="getExecutionDetails(item.name)" v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1">mdi-information</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="text-h6 grey lighten-2">
                            Output
                          </v-card-title>

                          <vue-json-pretty :path="'res'" :data="workflowExecutionDetails" :highlightMouseoverNode="1">
                          </vue-json-pretty>
                          <v-card-text>

                          </v-card-text>

                          <v-divider></v-divider>
                        </v-card>
                      </v-dialog>
                    </v-list-item>

                  </v-list>

                </div>
              </v-tab-item>





              <v-tab-item :value="'tab-errors'">

              </v-tab-item>
            </v-tabs-items>
          </v-navigation-drawer>
        </div>
      </div>
    </div>

    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogVisible" scrollable>
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Workflow</v-toolbar>
          <v-card-text>
            <div>
              <vue-json-pretty :path="'res'" :data="dialogData" :highlightMouseoverNode="1">
              </vue-json-pretty>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogVisible = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>
	

<!-- SCRIPT -->
<script>
import Drawflow from "drawflow";
import Vue from "vue";
import styleDrawflow from "../assets/css/drawflow-phinix.css";
import NodePlugin from "./nodes/NodePlugin.vue";
import VueJsonPretty from "vue-json-pretty";
import PhishingApi from "../app/phishing-api";
import "vue-json-pretty/lib/styles.css";

// Pass render Vue

export default {
  name: "WorkflowOrchestratorContent",
  data() {
    return {
      id: this.$refs.drawflow,
      editor: null,
      tab: null,
      newWorkflowName: null,
      currentWorkflowName: null,
      currentWorkflowId: null,
      currentWorkflowStatus: null,
      dialogCreateWorkflow: false,
      dialogGetExecutionDetails: [],
      workflowExecutions: [],
      workflowExecutionDetails:{},
      allWorkflows: [],
      searchplugin: "",
      settingsToggle: null,
      selectedNodeId: null,
      logoSelectedNodeId: null,
      descriptionSelectedNodeId: null,
      nameSelectedNodeId: null,
      settingsData: {},
      outputData:{},
      dialogData: {},
      dialogVisible: false,
      listNodes: [
      ],
    };
  },

  methods: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    async listPlugins() {
      let self = this;
      PhishingApi.listPlugins()
        .then((response) => {
          self.listNodes = response;
          self.listNodes.forEach((node) => {
            console.log(node)
            self.editor.registerNode(
              node["item"],
              NodePlugin,
              {
                logo: node["logo"],
                title: node["title"],
                subtitle: node["subtitle"],
              },
              {}
            );
          });
        })
        .catch((error) => {
          alert(
            "ERROR: Something went wrong. Try again or contact support if the error persists"
          );
        });
       
    },

    deleteWorkflow(id) {
      let json = {};
      let self = this;
      json["ids"] = [];
      json["ids"].push(id);
      PhishingApi.deleteWorkflow(json)
        .then((response) => {
          alert("Workflow " + id + " has been succesfully deleted");
          self.listWorkflows();
        })
        .catch((error) => {
          alert(
            "ERROR: Something went wrong. Try again or contact support if the error persists"
          );
        });
    },
    getExecutionDetails(name){
      let self = this;
      PhishingApi.getWorkflowExecutionDetails(this.currentWorkflowId,name).then((response)=>{
        console.log(response)
        self.workflowExecutionDetails = JSON.parse(response['body']['output']);
      })
    },
    getWorkflowRuns(id){
      let self=this;
      PhishingApi.getWorkflowExecutions(id).then((response) => {
        console.log( response['body']['executions']);
        self.workflowExecutions = response['body']['executions'];
      })
    },
    openWorkflow(id) {
      let self = this;
      PhishingApi.loadWorkflow(id).then((response) => {
        self.importEditor(response);
        self.getWorkflowRuns(id)
      });
      

    },
    listWorkflows() {
      PhishingApi.listWorkflows().then((response) => {
        console.log(response);
        this.allWorkflows = response;
      });
    },
    handleFileImport() {
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener("focus", () => {}, { once: true });

      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      let content;
      let file = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // this will then display a text file
          content = reader.result;
          this.importEditor(JSON.parse(content));
        },
        false
      );

      if (file) {
        reader.readAsText(file);
      }
    },
    executeWorkflow() {
      let self = this;
      PhishingApi.executeWorkflow(this.currentWorkflowId)
        .then((response) => {
          {
            if (response.statusCode == 200)
              alert("Workflow executed !");
            //get the latest runs
            self.getWorkflowRuns(this.currentWorkflowId);
            //self.listWorkflows();
          }
        })
        .catch((error) => {
          alert(error);
        });
    },


    deployWorkflow() {
      PhishingApi.deployWorkflow(this.currentWorkflowId)
        .then((response) => {
          { console.log(response)
            if (response.statusCode == 200)
            alert("Workflow is deployed and ready to be executed");
            //self.listWorkflows();
          }
        })
        .catch((error) => {
          alert("There was an error while deployng the workflow.");
        });
    },
    saveWorkflow() {
      let json = this.editor.export();
      let self = this;
      let workflow_json = {};
      workflow_json["workflow_name"] = this.currentWorkflowName;
      workflow_json["workflow_json"] =
        json.drawflow[this.editor.module]["data"];
      if (this.currentWorkflowId != null)
        workflow_json["id"] = this.currentWorkflowId;
      PhishingApi.saveWorkflow(workflow_json)
        .then((response) => {
          {
            if (response.id) self.currentWorkflowId = response.id;
            alert("Workflow has been saved");
            self.listWorkflows();
          }
        })
        .catch((error) => {
          alert("There was an error while saving the workflow.");
        });
    },
    importEditor(data) {
      //create a new editor with the name of the workflow
      this.editor.addModule(data["workflow_name"]);
      this.editor.changeModule(data["workflow_name"]);
      //build the drawflow json
      let wf = {};
      wf["drawflow"] = {};
      wf["drawflow"][data["workflow_name"]] = {};
      wf["drawflow"][data["workflow_name"]]["data"] = data["workflow_json"];
      console.log(wf);
      //import the workflow in the editor
      this.editor.import(wf);
      //change the name and the status of the imported workflow
      this.currentWorkflowName = this.editor.module; //should be the same as data["name"]
      //this.currentWorkflowStatus = data["status"];
      if (data["id"]) this.currentWorkflowId = data["id"];
    },
    createNewWorkflow() {
      this.editor.addModule(this.newWorkflowName);
      this.editor.changeModule(this.newWorkflowName);
      this.currentWorkflowName = this.editor.module;
      this.currentWorkflowId = null;
      this.dialogCreateWorkflow = false;
    },
    openSettingsDialog() {
      if (this.selectedNodeId != null)
        this.settingsToggle = !this.settingsToggle;
      else alert("Please select a node in the workflow to edit the settings");
    },
    savePluginSettings(data) {
      console.log(data);
      this.editor.updateNodeDataFromId(this.selectedNodeId, data);
      this.settingsToggle = false;
    },
    getSettingsForPlugin(id) {
      this.logoSelectedNodeId = null;
      this.descriptionSelectedNodeId = null;
      this.nameSelectedNodeId = null;
      this.outputData =null;
      let data = {};
      let self = this;
      PhishingApi.detailsPlugin(id)
        .then((response) => {
          {
            console.log('getSettingforPlugin called')
            console.log(response)
            self.logoSelectedNodeId = response.logo;
            self.descriptionSelectedNodeId = response.description;
            self.nameSelectedNodeId = response.title;
            self.settingsData = response.data;
            self.outputData = response.output_data;
          }
        })
        .catch((error) => {
          alert("There was an error while retrieving the settings for the plugin.");
        });

    },
      getSomeSettingsForPlugin(id) {
      this.logoSelectedNodeId = null;
      this.descriptionSelectedNodeId = null;
      this.nameSelectedNodeId = null;
      this.outputData =null;
      let data = {};
      let self = this;
      PhishingApi.detailsPlugin(id)
        .then((response) => {
          {
            console.log('getSettingforPlugin called')
            console.log(response)
            self.logoSelectedNodeId = response.logo;
            self.descriptionSelectedNodeId = response.description;
            self.nameSelectedNodeId = response.title;
            self.outputData = response.output_data;
        }
        })
        .catch((error) => {
          alert("There was an error while retrieving the settings for the plugin.");
        });

    },
    exportEditor() {
      this.dialogData = {};
      this.dialogData = this.editor.export();
      let workflow_json = {};
      workflow_json["workflow_name"] = this.editor.module;
      workflow_json["workflow_json"] =
        this.dialogData.drawflow[this.editor.module]["data"];
      this.dialogData = workflow_json;
      //this.dialogVisible = true;
      const blob = new Blob([JSON.stringify(workflow_json)], {
        type: "application/text",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = workflow_json["workflow_name"] + ".json";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    drag(ev) {
      ev.dataTransfer.setData("node", ev.target.getAttribute("data-node"));
    },
    drop(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("node");
      this.addNodeToDrawFlow(data, ev.clientX, ev.clientY);
    },
    allowDrop(ev) {
      ev.preventDefault();
    },

    addNodeToDrawFlow(name, pos_x, pos_y) {
      
      pos_x =
        pos_x *
          (this.editor.precanvas.clientWidth /
            (this.editor.precanvas.clientWidth * this.editor.zoom)) -
        this.editor.precanvas.getBoundingClientRect().x *
          (this.editor.precanvas.clientWidth /
            (this.editor.precanvas.clientWidth * this.editor.zoom));

      pos_y =
        pos_y *
          (this.editor.precanvas.clientHeight /
            (this.editor.precanvas.clientHeight * this.editor.zoom)) -
        this.editor.precanvas.getBoundingClientRect().y *
          (this.editor.precanvas.clientHeight /
            (this.editor.precanvas.clientHeight * this.editor.zoom));

      const nodeSelected = this.listNodes.find((ele) => ele.item == name);

      this.editor.addNode(
        name,
        nodeSelected.input,
        nodeSelected.output,
        pos_x,
        pos_y,
        name,
        {},
        name,
        "vue"
      );
    },
  },

  mounted: function () {
    this.listPlugins();
    this.listWorkflows();
    this.editor = new Drawflow(this.$refs.drawflow, Vue, this);
    Vue.prototype.$we = this.editor;
    this.editor.start();
    this.editor.useuuid = true;
    this.editor.reroute = true;
    this.currentWorkflowName = this.editor.module;
    //TODO: listNodes will be populated by the getPlugins API call
    
   

    let self = this;

    this.editor.on("connectionCreated", function (input) {
      let node = self.editor.getNodeFromId(input["input_id"]);
      if (node["inputs"]["input_1"]["connections"].length > 1) {
        alert("Sorry, we only support one input per plugin (for now)");
        //remove the connection
        self.editor.removeSingleConnection(
          input["output_id"],
          input["input_id"],
          input["output_class"],
          input["input_class"]
        );
      }
    });
    this.editor.on("nodeUnselected", function (result) {
      if (result) self.selectedNodeId = null;
    });
    // this event is triggered every time a node is selected.
    this.editor.on("nodeSelected", function (id) {
      console.log("Node selected" + id);
      self.selectedNodeId = id;
      let node = self.editor.getNodeFromId(id);
      console.log(Object.keys(node.data))
      //verifies that node.data is empty (new plugin has been added, without prior settings)
      if (Object.keys(node.data).length === 0) {
       self.logoSelectedNodeId = null;
       self.descriptionSelectedNodeId = null;
       self.nameSelectedNodeId = null;
       self.getSettingsForPlugin(node.name);
      } else {
        self.settingsData = node.data;
        self.getSomeSettingsForPlugin(node.name);
      }
    });
  },
    computed: {
    filteredList() {
      return this.listNodes.filter((plugin) => {
        return plugin.title.toLowerCase().includes(this.searchplugin.toLowerCase()) || plugin.subtitle.toLowerCase().includes(this.searchplugin.toLowerCase());
      });
    },
  },

  components: {
    VueJsonPretty,
  },
};
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #494949;
}
.container2 {
  width: 100%;
  
  padding: 12px;
}
.column {
  border-right: 1px solid #494949;
}
.column ul {
  padding-inline-start: 0px;
}
.column li {
  background: transparent;
}
.node {
  border-radius: 8px;
  border: 2px solid #494949;
  display: block;
  height: 60px;
  line-height: 40px;
  padding: 10px;
  margin: 10px 0px;
  cursor: move;
}
#drawflow {
  height: 100%;
  width: 100%;
  
}
.drawflow .drawflow-node {
  border-radius: 8px;
  background: #181818;
  border: 2px solid #494949;
  color: white;
  min-width: 250px;
}

.drawflow .drawflow-node.selected {
  background: #181818;
  border: 2px solid rgb(250, 0, 175);
}

.drawflow .drawflow-node .input,
.drawflow .drawflow-node .output {
  background: #181818;
  border: 3px solid #494949;
  width: 20px;
  height: 20px;
  margin-top: 14px;
  margin-bottom: 14px;
}

.drawflow .drawflow-node .input {
  left: -45px;
}

.drawflow .drawflow-node .output {
  right: -27px;
}

.drawflow .drawflow-node .output:hover,
.drawflow .drawflow-node .input:hover {
  background: #494949;
  border: 3px solid rgb(250, 0, 175);
}

.drawflow .connection .main-path {
  stroke-width: 3px;
  stroke: #c5c343;
}

.drawflow .connection .main-path:hover {
  stroke: rgb(250, 0, 175);
}

.parent-node .drawflow-delete {
  display: none !important;
}

.drawflow .drawflow-node.selected .drawflow_content_node .header {
  background: rgb(250, 0, 175);
}

.drawflow .drawflow-node .drawflow_content_node input,
.drawflow .drawflow-node .drawflow_content_node .el-select,
.drawflow .drawflow-node .drawflow_content_node button {
  width: 100%;
}

.el-drawer__body {
  color: white;
}
.single-node {
  background: #fff;
  border-radius: 20px;
  border: 1px #000 solid;
  margin-bottom: 10px;
}
</style>